import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import VueApexCharts from "vue3-apexcharts"
import router from './router'

createApp(App).use(router).use(Quasar, quasarUserOptions).use(VueApexCharts).mount('#app')
